import { render } from "./PauseView.vue?vue&type=template&id=22c223c7&scoped=true&ts=true"
import script from "./PauseView.vue?vue&type=script&lang=ts"
export * from "./PauseView.vue?vue&type=script&lang=ts"

import "./PauseView.vue?vue&type=style&index=0&id=22c223c7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c223c7"]])

export default __exports__